export default {
  title: "Reportes Auditoría"
  , form: {
    modulo: {
      label: "Módulo"
      , th: "Módulo"
    }
    , revision: { th: "Revisión" }
    , usuario: {
      label: "Usuario"
      , th: "Usuario"
    }
    , fecha: { th: "Fecha y hora" }
  }
  , errors: {
    BD4002: { text: "Ocurrió un error en el catálogo de Bitácora" }
    , WS4002: { text: "Ocurrió un error en el catálogo de Bitácora" }
    , JS4002: { text: "Ocurrió un error en el catálogo de Bitácora" }
    , CR4002: { text: "Ocurrió un error en el catálogo de Bitácora" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/bitacoras/reporteAuditoria.js